export default {

    methods: {
        changeSortList(field) {
            if (this.filters.sortBy === field) {
                this.filters.sortDir = this.filters.sortDir === 'asc' ? 'desc' : 'asc';
            }
            this.filters.sortBy = field
            this.updateList()
        },

        updateList() {
            if (typeof this.getList === 'function') {
                this.getList(this.filters)
            } else {
                console.error("getList method is not defined in the component")
            }
        }

    }
}
